module.exports = __webpack_public_path__ + "static/media/malmi-bg-map.4507621e.svg";